export const ACTIONS = {
  SET_PUBLIC_PHENOMENA_GROUPS: "SET_PUBLIC_PHENOMENA_GROUPS",
};
